import AxiosInstance from '../../core/api/axiosinstance'
import promiseToResult from '../../core/api/promiseToResults'

export interface EdkItem {
    symbol: string
    token: string
}

export interface GetEdkReq {
    userId: number
}

export interface downloadEdkReq {
    userId: number,
    symbol: string
}

export interface GetEdkRes {
    message: string
    status: boolean
    code: number
    data: EdkItem[]
}

const getUserEdk = (data: GetEdkReq) => {
    const { userId } = data
    return promiseToResult(
        AxiosInstance().get<GetEdkRes>(
            `/projects/admin/transactions/edk/${userId}`,
        ),
    )
}

const downloadUserEdk = (data: downloadEdkReq) => {
    const { userId, symbol } = data
    return promiseToResult(
        AxiosInstance().get<Blob>(
            `/projects/admin/transactions/edk/${userId}/${symbol}.pdf`,
            {
                responseType: 'arraybuffer',
            },
        ),
    )
}

export const EdkAPI = {
    getUserEdk,
    downloadUserEdk,
}
